import { render, staticRenderFns } from "./CompSalesCard.vue?vue&type=template&id=74dafaf2&scoped=true"
import script from "./CompSalesCard.vue?vue&type=script&lang=js"
export * from "./CompSalesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dafaf2",
  null
  
)

export default component.exports